import { Component, input, output } from '@angular/core';
import { ButtonComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';

/**
 * Package step footer with Back navigation and Save and Continue (page validates and,
 * when valid, advances to the Service step). During initial catalog skeleton loading the
 * page replaces this footer with skeleton action placeholders (OM-711 AC7); this component
 * is not shown until the catalog is ready.
 */
@Component({
  selector: 'app-package-selection-actions',
  imports: [ButtonComponent, TranslatePipe],
  templateUrl: './package-selection-actions.html',
  styleUrl: './package-selection-actions.scss',
})
export class PackageSelectionActions {
  /**
   * When true, Back and Save and Continue are disabled (non-skeleton busy states).
   */
  readonly interactionDisabled = input(false);
  /**
   * True while account lookup (and navigation) runs after Save and Continue.
   * Also disables Back so the customer cannot leave mid-save.
   */
  readonly loading = input(false);

  /** Emits when Save and Continue is clicked so the page can show client-side validation only. */
  readonly saveAttempted = output<void>();
  /** Emitted when the customer clicks Back (page owns navigation). */
  readonly backRequested = output<void>();

  /**
   * Notifies the page to validate without advancing the wizard.
   */
  protected onSaveAttempt(): void {
    if (this.interactionDisabled() || this.loading()) {
      return;
    }

    this.saveAttempted.emit();
  }

  /**
   * Asks the page to navigate back to Ship From / Ship To.
   */
  protected onBack(): void {
    if (this.interactionDisabled() || this.loading()) {
      return;
    }
    this.backRequested.emit();
  }
}
